<table *ngIf="weatherReport.weatherDetailReport.length || dprWeather.comment" class="layout-fixed striped">
  <colgroup>
    <col *ngFor="let item of weatherList" class="width-{{weatherReport.columnWidth}}" />
  </colgroup>
  <thead>
    <tr>
      <th [colSpan]="weatherReport.columnNumber">
        <h3>{{customNames.weatherTabName}}</h3>
      </th>
    </tr>
  </thead>
  <ng-container *ngIf="weatherReport.weatherDetailReport.length">
    <tbody class="secondary-header">
      <tr>
        <td class="text-center">{{StaticMessage.PriorityColumn | staticMessage}}</td>
        <td class="text-center" i18n="@@report.reportWeather.colTime">Time</td>
        <td class="text-center" *ngFor="let projectSetupWeather of weatherList">
          {{projectSetupWeather.name}}
          <p class="no-bold" *ngIf="projectSetupWeather.units">[{{projectSetupWeather.units}}]</p>
        </td>
      </tr>
    </tbody>
  </ng-container>
  <tbody *ngFor="let weather of weatherReport.weatherDetailReport; index as weatherIndex">
    <tr>
      <td class="text-center accent">{{weatherIndex + 1}}</td>
      <td class="text-center">{{ weather.time }}</td>
      <td class="text-center" *ngFor="let detailItem of weather.dprWeatherDetailsItems">
        {{ detailItem.value ?? '' }}
      </td>
    </tr>
  </tbody>
  <tbody class="secondary-header" *ngIf="dprWeather.comment">
    <tr>
      <td [colSpan]="weatherReport.columnNumber">{{StaticMessage.CommentPluralLabel | staticMessage}}</td>
    </tr>
  </tbody>
  <tbody *ngIf="dprWeather.comment">
    <tr>
      <td
        [colSpan]="weatherReport.columnNumber"
        class="white-space-pre-wrap"
        [innerHTML]="(dprWeather.comment | trim) || '-'"
      ></td>
    </tr>
  </tbody>
</table>
